<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper sales-list">
    <div class="content">
      <div v-if="isLoading" class="page-loading-overlay">
        <div class="spinner-border text-primary dashboard-spinner" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>List des Factures</h4>
            <h6>Gérer vos Factures</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf" @click.prevent="exportPDF">
              <img src="@/assets/img/icons/pdf.svg" alt="img" />
            </a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel" @click.prevent="exportCSV">
              <img src="@/assets/img/icons/excel.svg" alt="img" />
            </a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print" @click.prevent="printTable">
              <vue-feather type="printer" class="printer"></vue-feather>
            </a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh" @click.prevent="refreshList">
              <vue-feather type="rotate-ccw" class="rotate-ccw"></vue-feather>
            </a>
          </li>
          <li>
            <a ref="collapseHeader" data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse"
              @click="toggleCollapse">
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a v-can="'invoices.create'" href="javascript:void(0);" class="btn btn-added" data-bs-toggle="modal"
            data-bs-target="#add-sales-new"><vue-feather type="plus-circle" class="me-2"></vue-feather> Ajouter
            une nouvelle Facture</a>
        </div>
      </div>

      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top d-flex align-items-center justify-content-between flex-wrap">
            <div class="search-set">
              <div class="search-input">
                <input type="text" placeholder="Recherche" class="dark-input" v-model="searchQuery"
                  @input="applyFilters" @keyup.enter="applyFilters" />
                <a href="" class="btn btn-searchset" @click.prevent="applyFilters"><i data-feather="search"
                    class="feather-search"></i></a>
              </div>
            </div>
            <div class="filter-set d-flex gap-2 mb-2">
              <!-- Statut -->
              <select class="form-select form-select-sm" v-model="filterStatus" @change="applyFilters">
                <option value="">Tous les Statuts</option>
                <option value="Payé">Payé</option>
                <option value="Impayé">Impayé</option>
                <option value="Partiellement payé">Partiellement payé</option>
                <option value="Annulé">Annulé</option>
                <option value="En retard">En retard</option>
              </select>

              <!-- Déclarée -->
              <select class="form-select form-select-sm" v-model="filterDeclare" @change="applyFilters">
                <option value="">Toutes</option>
                <option value="true">Déclarée</option>
                <option value="false">Non déclarée</option>
              </select>

              <!-- Nom Client -->
              <select class="form-select form-select-sm" v-model="filterClient" @change="applyFilters">
                <option value="">Tous les Clients</option>
                <option v-for="c in clientData" :key="c" :value="c">{{ c }}</option>
              </select>
            </div>
          </div>

          <transition name="batch-bar">
            <div v-if="selectedInvoiceKeys.length" class="invoice-batch-bar">
              <div class="invoice-batch-summary">
                <span class="invoice-batch-icon"><vue-feather type="check-square"></vue-feather></span>
                <div>
                  <strong>{{ $t('invoiceBatch.selected', selectedInvoiceKeys.length, { count: selectedInvoiceKeys.length }) }}</strong>
                  <small>{{ $t('invoiceBatch.hint') }}</small>
                </div>
              </div>
              <div class="invoice-batch-actions">
                <button type="button" class="btn btn-link" :disabled="batchDownloading" @click="clearInvoiceSelection">
                  {{ $t('invoiceBatch.clear') }}
                </button>
                <button type="button" class="btn btn-added batch-download-btn" :disabled="batchDownloading"
                  @click="downloadSelectedInvoices">
                  <span v-if="batchDownloading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                  <vue-feather v-else type="download-cloud"></vue-feather>
                  {{ batchDownloading ? $t('invoiceBatch.preparing') : $t('invoiceBatch.download') }}
                </button>
              </div>
            </div>
          </transition>

          <!-- /Filter -->
          <!-- Filters removed, search only -->
          <div class="table-responsive">
            <a-table :columns="columns" :data-source="filteredData" :row-key="invoiceRowKey"
              :row-selection="invoiceRowSelection">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Status'">
                  <div>
                    <span :class="record.Status_class">{{
                      record.Status
                      }}</span>
                  </div>
                </template>
                <template v-else-if="column.key === 'Payment_Status'">
                  <div>
                    <span :class="record.Payment_Class">{{
                      record.Payment_Status
                      }}</span>
                  </div>
                </template>
                <template v-else-if="column.key === 'declare'">
                  <div>
                    <template v-if="$can('invoices.declare')">
                      <select class="form-select form-select-sm declare-select"
                        :value="record.declare ? 'true' : 'false'"
                        :disabled="declareLoading[record.id]"
                        @change="onDeclareChange(record, $event)">
                        <option value="false">Non déclarée</option>
                        <option value="true">Déclarée</option>
                      </select>
                    </template>
                    <template v-else>
                      <span :class="record.declare_class">{{ record.declare_label }}</span>
                    </template>
                  </div>
                </template>
                <template v-else-if="column.key === 'action'">
                  <div class="action-table-data">
                    <div class="edit-delete-action">
                      <a class="me-2 edit-icon p-2" href="javascript:void(0);" @click="viewFacture(record)"
                        title="Voir facture">
                        <i data-feather="eye" class="feather-eye"></i>
                      </a>
                      <a v-can="'invoices.update'" class="me-2 p-2" href="javascript:void(0);" data-bs-toggle="modal"
                        data-bs-target="#edit-sales-new" @click="openEditModal(record)">
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a v-can="'payments.view'" class="me-2 p-2" href="javascript:void(0);" @click="openPayments(record)" title="Paiements">
                        <vue-feather type="credit-card" class="info-img"></vue-feather>
                      </a>
                      <a v-can="'invoices.download'" class="me-2 p-2" href="javascript:void(0);" @click="handlePdf(record)"><vue-feather
                          type="download" class="info-img"></vue-feather></a>
                      <a v-can="'invoices.delete'" class="confirm-text p-2" @click="
                        showConfirmation(
                          record.id,
                          record.devis_id,
                          record.commande_id
                        )
                        " href="javascript:void(0);">
                        <vue-feather type="trash-2" class="trash-2"></vue-feather>
                      </a>
                    </div>
                  </div>
                  <!-- <div class="text-center">
                    <a
                      class="action-set"
                      href="javascript:void(0);"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </a>
                    <ul class="dropdown-menu sales-list-icon">
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#sales-details-new"
                          ><vue-feather
                            type="eye"
                            class="info-img"
                          ></vue-feather
                          >Sale Detail</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-sales-new"
                          ><vue-feather
                            type="edit"
                            class="info-img"
                          ></vue-feather
                          >Edit Sale</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#showpayment"
                          ><vue-feather
                            type="dollar-sign"
                            class="info-img"
                          ></vue-feather
                          >Show Payments</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#createpayment"
                          ><vue-feather
                            type="plus-circle"
                            class="info-img"
                          ></vue-feather
                          >Create Payment</a
                        >
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item"
                          ><vue-feather
                            type="download"
                            class="info-img"
                          ></vue-feather
                          >Download pdf</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item confirm-text mb-0"
                          ><vue-feather
                            type="trash-2"
                            class="info-img"
                          ></vue-feather
                          >Delete Sale</a
                        >
                      </li>
                    </ul>
                  </div> -->
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>

  <invoices-list-modal @facture-added="onFactureAdded" @edit-added="onFactureUpdated"
    :data="selectedDevis"></invoices-list-modal>

  <!-- View facture modal -->
  <div class="modal fade" id="facture-view-modal" tabindex="-1" aria-hidden="true" ref="viewModalEl">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable invoice-detail-dialog">
      <div class="modal-content invoice-detail-modal">
        <div class="modal-header invoice-detail-header">
          <div>
            <div class="invoice-detail-eyebrow">Facturation</div>
            <h5 class="modal-title">Détail de la facture</h5>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body invoice-detail-body" v-if="selectedFacture">
          <!-- Header: company + invoice metadata -->
          <div class="invoice-hero d-flex justify-content-between align-items-start mb-4">
            <div>
              <div class="invoice-company-label">Émetteur</div>
              <h5 class="mb-1">{{ company.name || 'Société' }}</h5>
              <div class="small text-muted">
                {{ company.address || '' }}<br />
                {{ company.email || '' }} {{ company.telephone_personnel ? ' | ' + company.telephone_personnel : '' }}
              </div>
            </div>
            <div class="text-end">
              <div class="invoice-number-label">Facture</div>
              <div class="invoice-number">{{ selectedFacture.numero_facture || `#${selectedFacture.id}` }}</div>
              <div class="small text-muted">
                Date : {{ formatDate(selectedFacture.date_creation || selectedFacture.CreatedOn) }}<br />
                Statut : <span :class="statusBadge(selectedFacture.statut_paiement)">{{
                  statusLabel(selectedFacture.statut_paiement) }}</span>
              </div>
            </div>
          </div>

          <!-- Parties: billing and invoice info -->
          <div class="row g-3 mb-4">
            <div class="col-md-6">
              <div class="invoice-info-card h-100">
                <div class="invoice-card-title"><vue-feather type="user" size="17"></vue-feather> Facturé à</div>
                <div class="fw-semibold">{{ selectedFacture.client_nom || '—' }}</div>
                <div class="small text-muted">
                  {{ (selectedFacture.commande && selectedFacture.commande.client_adresse) || '' }}
                </div>
                <div class="small text-muted mt-2">
                  Mode paiement: {{ selectedFacture.mode_paiement || '—' }}
                </div>
                <div class="small text-muted">
                  Conditions: {{ selectedFacture.conditions_paiement || '—' }}
                </div>
                <div v-if="selectedFacture.client_type === 'COMPANY' && selectedFacture.client_ice" class="small text-muted">
                  ICE: {{ selectedFacture.client_ice }}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="invoice-info-card h-100">
                <div class="invoice-card-title"><vue-feather type="file-text" size="17"></vue-feather> Informations facture</div>
                <div><strong>Commande :</strong> {{ selectedFacture.commande_id || '—' }}</div>
                <div><strong>Devis :</strong> {{ selectedFacture.numero_devis || selectedFacture.devis_id || '—' }}</div>
                <div><strong>Créé par :</strong> {{ selectedFacture.created_by_name || '—' }}</div>
                <div><strong>Modifié par :</strong> {{ selectedFacture.updated_by_name || '—' }}</div>
                <div><strong>Valide jusqu'au :</strong> {{ selectedFacture.valide_jusqua ? formatDate(selectedFacture.valide_jusqua) : '—' }}</div>
                <div><strong>Date de livraison :</strong> {{ selectedFacture.date_livraison ? formatDate(selectedFacture.date_livraison) : '—' }}</div>
                <div><strong>Référence interne :</strong> {{ selectedFacture.id }}</div>
              </div>
            </div>
          </div>

          <!-- Line items -->
          <div class="invoice-lines mb-4">
            <div class="invoice-section-title">Articles facturés</div>
            <a-table class="invoice-lines-table" :columns="factureLineColumns" :data-source="formattedFactureLines" :pagination="false"
              row-key="description" :locale="{ emptyText: 'Aucun article' }">
            </a-table>
          </div>

          <!-- Totals -->
          <div class="row g-3 mb-4">
            <div class="col-lg-5 ms-auto">
            <div class="invoice-totals-card">
                <div class="d-flex justify-content-between mb-2">
                  <div>Subtotal HT</div>
                  <div class="fw-semibold">
                    {{ formatAmount(factureTotals.totalHT) }}
                  </div>
                </div>

                <div class="d-flex justify-content-between mb-2">
                  <div>Total TVA</div>
                  <div class="fw-semibold">
                    {{ formatAmount(factureTotals.totalTVA) }}
                  </div>
                </div>

                <div class="d-flex justify-content-between mb-2">
                  <div>Montant payé</div>
                  <div class="fw-semibold text-success">
                    {{ formatAmount(selectedFacture.montant_payé) }}
                  </div>
                </div>

                <div class="d-flex justify-content-between mb-2">
                  <div>Reste à payer</div>
                  <div class="fw-semibold text-danger">
                    {{ formatAmount(selectedFacture.montant_restant) }}
                  </div>
                </div>

                <div class="invoice-total-divider"></div>

                <div class="d-flex justify-content-between fs-5">
                  <div>Total TTC</div>
                  <div class="fw-bold text-primary">
                    {{ formatAmount(factureTotals.totalTTC) }}
                  </div>
                </div>
            </div>
            </div>
          </div>

          <!-- Notes & signed file -->
          <div class="row g-3">
            <div class="col-md-8">
              <div class="invoice-info-card h-100">
                <h6 class="mb-2 text-muted">Notes</h6>
                <div>{{ selectedFacture.notes || '—' }}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="invoice-info-card h-100 text-center">
                <h6 class="mb-2 text-muted">Fichier signé</h6>
                <div v-if="selectedFacturePdfUrl">
                  <a :href="selectedFacturePdfUrl" target="_blank"
                    class="btn btn-outline-primary btn-sm mb-2">Télécharger</a>
                  <div class="small text-muted d-block">{{ isPdfFile(selectedFacturePdfUrl) ? 'PDF' : 'Image' }}</div>
                </div>
                <div v-else class="text-muted">Aucun fichier</div>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="invoice-detail-actions d-flex justify-content-end gap-2">
            <button class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            <button class="btn btn-primary" @click="openPdf">
              Imprimer / Télécharger
            </button>
          </div>
        </div>
        <div v-else class="p-3 text-center text-muted">Sélectionnez une facture pour voir les détails.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFacturesData as fetchFacturesData, deleteFacture, updateFactureDeclare } from "@/services/facturesService";
import { getClientsData } from "@/services/clientsService";
import { generateCommandPdf } from "@/services/pdfService";
import { getCompanyLogoDataUrl } from "@/services/companyService";
import { getCompanyData as fetchCompanyData } from "@/services/companyService";
import { getLignesCommandeDataByCommandeId } from "@/services/devisService";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "vue3-toastify";
import Swal from "sweetalert2";
import JSZip from "jszip";
import { getCurrentUser } from "@/services/authService";

const columns = [

  {
    title: "Référence du facture",
    dataIndex: "numero_facture",
    sorter: {
      compare: (a, b) => String(a?.numero_facture || "").localeCompare(String(b?.numero_facture || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Nom Client",
    dataIndex: "client_nom",
    sorter: {
      compare: (a, b) => String(a?.client_nom || "").localeCompare(String(b?.client_nom || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Devis",
    dataIndex: "numero_devis",
    sorter: {
      compare: (a, b) => String(a?.numero_devis || "").localeCompare(String(b?.numero_devis || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Date",
    dataIndex: "CreatedOn",
    sorter: {
      compare: (a, b) => {
        const pa = (v) => (v ? new Date(v).getTime() || 0 : 0);
        const va = pa(a?.date_creation || a?.CreatedOn);
        const vb = pa(b?.date_creation || b?.CreatedOn);
        return va - vb;
      },
    },
  },
  {
    title: "Créé par",
    dataIndex: "created_by_name",
    sorter: {
      compare: (a, b) => String(a?.created_by_name || "").localeCompare(String(b?.created_by_name || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Modifié par",
    dataIndex: "updated_by_name",
    sorter: {
      compare: (a, b) => String(a?.updated_by_name || "").localeCompare(String(b?.updated_by_name || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Statut",
    dataIndex: "Payment_Status",
    key: "Payment_Status",
    sorter: {
      compare: (a, b) => String(a?.Payment_Raw || "").localeCompare(String(b?.Payment_Raw || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Déclarée",
    dataIndex: "declare_label",
    key: "declare",
    sorter: {
      compare: (a, b) => (a?.declare ? 1 : 0) - (b?.declare ? 1 : 0),
    },
  },
  {
    title: "Totale du Commande",
    dataIndex: "montant_total",
    sorter: {
      compare: (a, b) => (Number(a?.montant_total) || 0) - (Number(b?.montant_total) || 0),
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const data = [];
const clientData = [];
const clientIds = [];
const clients = [];
// const factureLineColumns = [
//   { title: 'Description', dataIndex: 'description', key: 'description' },
//   { title: 'Quantité', dataIndex: 'quantite', key: 'quantite', align: 'center' },
//   { title: 'PU HT', dataIndex: 'prix_unitaire', key: 'prix_unitaire', align: 'right' },
//   { title: 'TVA %', dataIndex: 'tva', key: 'tva', align: 'center' },
//   { title: 'Total HT', dataIndex: 'montant_HT', key: 'montant_HT', align: 'right' },
//   { title: 'Total TTC', dataIndex: 'montant_TTC', key: 'montant_TTC', align: 'right' },
// ];
export default {
  data() {
    return {

      searchQuery: "",
      filteredData: [],
      filterStatus: "",
      filterDeclare: "",
      filterClient: "",
      columns,
      data,
      selectedDevis: {},
      selectedFacture: null,
      selectedFactureLines: [],
      selectedFacturePdfUrl: null,
      viewModal: null,
      clientData,
      clientIds,
      company: {},
      clients,
      currentUser: null,
      isAdmin: false,
      declareLoading: {},
      isLoading: false,
      selectedInvoiceKeys: [],
      selectedInvoiceRows: [],
      batchDownloading: false,
      factureLineColumns: [
        { title: 'Description', dataIndex: 'description', width: '34%' },
        { title: 'Quantité', dataIndex: 'quantite', align: 'center', width: 90 },
        { title: 'PU HT', dataIndex: 'prix_unitaire', align: 'right' },
        { title: 'TVA', dataIndex: 'tva', align: 'center', width: 80 },
        { title: 'Total HT', dataIndex: 'montant_HT', align: 'right' },
        { title: 'Total TTC', dataIndex: 'montant_TTC', align: 'right' },
      ],
    };
  },
  computed: {
    invoiceRowSelection() {
      return {
        selectedRowKeys: this.selectedInvoiceKeys,
        onChange: (keys, rows) => {
          this.selectedInvoiceKeys = keys;
          this.selectedInvoiceRows = rows;
        },
      };
    },
    formattedFactureLines() {
      return this.selectedFactureLines.map(line => ({
        description: line.nom_libre || line.item_data?.nom || '-',
        quantite: line.quantite,
        prix_unitaire: this.formatAmount(line.prix_unitaire),
        tva: line.montant_HT && line.montant_TTC
          ? (((line.montant_TTC - line.montant_HT) / line.montant_HT) * 100).toFixed(0) + ' %'
          : '0 %',
        montant_HT: this.formatAmount(line.montant_HT),
        montant_TTC: this.formatAmount(line.montant_TTC),
      }));
    },

    factureTotals() {
      return this.getTotals(this.selectedFactureLines);
    }
  }
  ,

  methods: {
    invoiceRowKey(record) {
      return record.id || record.numero_facture;
    },
    clearInvoiceSelection() {
      this.selectedInvoiceKeys = [];
      this.selectedInvoiceRows = [];
    },
    async downloadSelectedInvoices() {
      if (!this.selectedInvoiceRows.length || this.batchDownloading) return;
      this.batchDownloading = true;
      const zip = new JSZip();
      try {
        for (const invoice of this.selectedInvoiceRows) {
          const pdf = await this.handlePdf(invoice, { returnBlob: true, silent: true });
          if (!pdf?.blob) throw new Error(`PDF unavailable for ${invoice.numero_facture || invoice.id}`);
          zip.file(pdf.filename, pdf.blob);
        }
        const archive = await zip.generateAsync({ type: "blob", compression: "DEFLATE" });
        const url = URL.createObjectURL(archive);
        const link = document.createElement("a");
        link.href = url;
        link.download = `factures-${new Date().toISOString().slice(0, 10)}.zip`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        toast.success(this.$t("invoiceBatch.success", this.selectedInvoiceRows.length, { count: this.selectedInvoiceRows.length }));
        this.clearInvoiceSelection();
      } catch (error) {
        console.error("Batch invoice download failed:", error);
        toast.error(this.$t("invoiceBatch.error"));
      } finally {
        this.batchDownloading = false;
      }
    },
    getTotals(lignes = []) {
      if (!Array.isArray(lignes)) {
        return { totalHT: 0, totalTVA: 0, totalTTC: 0 };
      }

      let totalHT = 0;
      let totalTVA = 0;

      lignes.forEach(l => {
        const qte = Number(l.quantite || 1);
        const prix = Number(l.prix_unitaire || 0);
        const tva = Number(l.montant_HT && l.montant_TTC
          ? (((l.montant_TTC - l.montant_HT) / l.montant_HT) * 100).toFixed(0)
          : 0 || 0);

        const ht = qte * prix;
        const tvaValue = ht * (tva / 100);

        totalHT += ht;
        totalTVA += tvaValue;

      });

      return {
        totalHT,
        totalTVA,
        totalTTC: totalHT + totalTVA
      };
    },
    openPdf() {
      if (!this.selectedFacture?.id) {
        this.$message.error('Facture introuvable');
        return;
      } else {
        this.handlePdf(this.selectedFacture);
      }


    },
    normalize(str) {
      return String(str ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },

    applyFilters() {
      const q = this.normalize(this.searchQuery || '').trim();
      this.filteredData = this.data.filter((r) => {
        // Filter by search text
        const matchesSearch =
          !q ||
          [
            r.numero_facture,
            r.client_nom,
            r.Payment_Status,
            r.mode_paiement,
            r.numero_devis,
            r.montant_total,
            r.CreatedOn,
            r.date_creation,
            r.declare_label,
            r.created_by_name,
            r.updated_by_name,
          ]
            .filter((v) => v !== undefined && v !== null)
            .map((v) => this.normalize(v))
            .some((v) => v.includes(q));

        // Filter by Statut
        const matchesStatus =
          !this.filterStatus || r.Payment_Status === this.filterStatus;

        // Filter by Déclarée
        const matchesDeclare =
          !this.filterDeclare ||
          (this.filterDeclare === "true" && r.declare) ||
          (this.filterDeclare === "false" && !r.declare);

        // Filter by Nom Client
        const matchesClient =
          !this.filterClient || r.client_nom === this.filterClient;

        // Row is included only if all filters pass
        return matchesSearch && matchesStatus && matchesDeclare && matchesClient;
      });
    },
    showConfirmation(id_facture, id_devis, id_commandes) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer ce Devis ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteFacture(id_facture, id_devis, id_commandes);

            // Refresh list so table reflects server state
            await this.getFacturesData();
            this.applyFilters();
            Swal.fire({
              icon: "success",
              title: "Supprimé!",
              text: "Votre facture a été supprimée.",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            const msg =
              error?.response?.data?.error ||
              error?.response?.data?.message ||
              error?.message ||
              "Une erreur est survenue";
            toast.error(msg);
          }
        }
      });
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    setDeclareLoading(id, value) {
      this.declareLoading = { ...this.declareLoading, [id]: value };
    },
    async onDeclareChange(record, event) {
      const selectEl = event.target;
      const desired = selectEl.value === "true";

      if (record.declare === desired) {
        return;
      }

      this.setDeclareLoading(record.id, true);
      try {
        await updateFactureDeclare(record.id, desired);
        record.declare = desired;
        record.declare_label = desired ? "Déclarée" : "Non déclarée";
        record.declare_class = desired
          ? "badges bg-lightgreen"
          : "badges bg-lightred";
        const original = this.data.find((item) => item.id === record.id);
        if (original) {
          original.declare = record.declare;
          original.declare_label = record.declare_label;
          original.declare_class = record.declare_class;
        }
        selectEl.value = desired ? "true" : "false";
        toast.success(
          desired
            ? "Facture marquée comme déclarée."
            : "Facture marquée comme non déclarée."
        );
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Impossible de mettre à jour le statut de déclaration.";
        toast.error(msg);
        selectEl.value = record.declare ? "true" : "false";
      } finally {
        this.setDeclareLoading(record.id, false);
        this.applyFilters();
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    async getClientsData() {
      this.clientData = [];
      this.clientIds = [];
      try {
        const data = await getClientsData();
        data.map((m) => {
          const displayName = (m.nom_societe && m.nom_societe.trim())
            ? m.nom_societe
            : [m.prenom, m.nom].filter(Boolean).join(' ').trim();
          this.clientData.push(displayName);
          this.clients.push(m);
          this.clientIds.push(m.id);
        });
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      }
    },
    getClientID(option) {
      let index = this.clientData.indexOf(option);
      if (index != -1) {
        return this.clientIds[index];
      }
      return index;
    },
    getClientName(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clientData[index];
      }
      return index;
    },
    findClient(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clients[index];
      }
      return index;
    },
    // async getDevisData() {
    //   this.data = [];
    //   try {
    //     const data = await getDevisData();
    //     data.map((m) => {
    //       this.data.push({
    //         id: m.id,
    //         statut: m.statut,
    //         commande_id: m.commande_id,
    //         numero_devis: m.numero_devis,
    //         valide_jusqua: m.valide_jusqua,
    //         notes: m.notes,
    //         commande: m.commande,
    //         societe_id: m.societe_id,
    //         mode_paiement: m.commande.mode_paiement,
    //         montant_total: m.commande.montant_total,
    //         montant_taxe: m.commande.montant_taxe,
    //         client_nom: this.getClientName(1),
    //         client_id: m.commande.client_id,
    //         CreatedOn: this.formatDate(m.created_at),
    //       });
    //     });
    //   } catch (error) {
    //     console.error(error);
    //     toast.error(error.response.data.message);
    //   }
    // },
    async onFactureAdded() {
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Facture créé avec succès.",
        confirmButtonClass: "btn btn-success",
      });
      await this.getClientsData();
      await this.getFacturesData();
    },
    async onFactureUpdated() {
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Facture modifiée avec succès.",
        confirmButtonClass: "btn btn-success",
      });
      await this.getClientsData();
      await this.getFacturesData();
    },
    async openViewModal() {
      const { Modal } = await import("bootstrap");
      if (!this.viewModal && this.$refs.viewModalEl) {
        this.viewModal = new Modal(this.$refs.viewModalEl, { backdrop: "static" });
      }
      this.viewModal?.show();
    },
    async viewFacture(record) {
      this.selectedFacture = record;
      this.selectedFactureLines = [];
      try {
        if (record.commande_id) {
          const lines = await getLignesCommandeDataByCommandeId(record.commande_id);
          this.selectedFactureLines = Array.isArray(lines) ? lines : [];
        }
      } catch (e) {
        toast.error("Impossible de charger les lignes de la facture");
      }


      const baseUrl = process.env.VUE_APP_URL || window.location.origin;
      this.selectedFacturePdfUrl = record.pdf ? `${baseUrl.replace(/\/$/, "")}/storage/${record.pdf}` : null;
      this.openViewModal();
    },
    isPdfFile(url) {
      return /\.pdf(?:$|\?)/i.test(String(url || ""));
    },
    formatAmount(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num.toFixed(2) : "—";
    },

    async getFacturesData() {
      this.isLoading = true;
      this.data = [];
      try {
        const data = await fetchFacturesData();
        (Array.isArray(data) ? data : []).map((m) => {
          const rawPay = String(m.statut_paiement || '').toUpperCase();
          const isDeclared = Boolean(m.declare);
          this.data.push({
            id: m.id,
            statut_paiement: m.statut_paiement,
            Payment_Raw: rawPay,
            Payment_Status: this.statusLabel(rawPay),
            Payment_Class: this.statusBadge(rawPay),
            commande_id: m.commande_id,
            devis_id: m.devis_id || m.commande?.devis_id || null,
            numero_devis: m.devis?.numero_devis || "",
            numero_facture: m.numero_facture,
            notes: m.commande?.notes || "",
            commande: m.commande || null,
            pdf: m.pdf || null,
            date_creation: m.date_creation,
            date_echeance: m.date_echeance ?? null,
            valide_jusqua: m.valide_jusqua ?? null,
            date_livraison: m.date_livraison ?? m.commande?.date_livraison ?? null,
            societe_id: m.societe_id,
            mode_paiement: m.commande?.mode_paiement || "",
            conditions_paiement: m.conditions_paiement ?? m.commande?.conditions_paiement ?? "",
            montant_total: m.montant_total ?? null,
            montant_taxe: m.montant_taxe ?? null,
            montant_payé: m.montant_payé ?? null,
            montant_restant: m.montant_restant ?? null,
            payments_count: Number(m.payments_count || 0),
            has_linked_payments: Number(m.payments_count || 0) > 0,
            client_nom: m.client_name || this.getClientName(m.commande?.client_id),
            client_id: m.commande?.client_id ?? null,
            client_type: m.client_type || m.commande?.client?.type || "",
            client_ice: m.client_ice || m.commande?.client?.ice || "",
            client_nom_societe: m.client_nom_societe || m.commande?.client?.nom_societe || "",
            created_by: m.created_by ?? null,
            updated_by: m.updated_by ?? null,
            created_by_name: m.creator?.name || m.creator?.email || "—",
            updated_by_name: m.updater?.name || m.updater?.email || "—",
            CreatedOn: this.formatDate(m.created_at),
            declare: isDeclared,
            declare_label: isDeclared ? "Déclarée" : "Non déclarée",
            declare_class: isDeclared ? "badges bg-lightgreen" : "badges bg-lightred",
          });
        });
        this.filteredData = [...this.data];
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      } finally {
        this.isLoading = false;
      }
    },

    // Map payment status to badge class
    statusBadge(status) {
      const s = String(status || "").toUpperCase();
      switch (s) {
        case "PAYÉ":
          return "badges bg-lightgreen"; // green
        case "IMPAYÉ":
          return "badges bg-lightred"; // red
        case "PARTIELLEMENT_PAYÉ":
          return "badges bg-lightyellow"; // yellow
        case "ANNULÉ":
          return "badges bg-lightred"; // red
        case "EN_RETARD":
          return "badges bg-lightyellow"; // amber
        default:
          return "badges status-badge";
      }
    },

    // Localized (FR) label for payment status codes
    statusLabel(status) {
      const s = String(status || "").toUpperCase();
      switch (s) {
        case "PAID":
        case "PAYE":
        case "PAYÉ":
          return "Payé";
        case "UNPAID":
        case "IMPAYE":
        case "IMPAYÉ":
          return "Impayé";
        case "PARTIALLY_PAID":
        case "PARTIELLEMENT_PAYE":
        case "PARTIELLEMENT_PAYÉ":
          return "Partiellement payé";
        case "CANCELLED":
        case "ANNULE":
        case "ANNULÉ":
          return "Annulé";
        case "OVERDUE":
        case "EN_RETARD":
          return "En retard";
        default:
          // Fallback: Title-case the raw value replacing underscores
          return s
            .toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());
      }
    },

    openEditModal(item) {
      this.selectedDevis = item;
    },
    openPayments(record) {
      this.$router.push({
        path: "/factures/paiements",
        query: { facture_id: record.id },
      });
    },

    // Print the current table view (filtered if a search is active) with logo + footer
    async printTable() {
      const rows = this.filteredData && this.filteredData.length ? this.filteredData : this.data;
      const win = window.open("", "_blank");
      if (!win) return;
      let logo = "";
      try { logo = await getCompanyLogoDataUrl('logo'); } catch (_) { /* ignore logo fetch */ }
      const c = this.company || {};
      const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const line1 = esc(c.name || '');
      const line2 = esc([c.address, c.code_postal].filter(Boolean).join(' | '));
      const line3 = esc([c.email, c.url].filter(Boolean).join(' | '));
      const taxBits = [];
      if (c.rc) taxBits.push(`RC: ${esc(c.rc)}`);
      if (c.if) taxBits.push(`IF: ${esc(c.if)}`);
      if (c.ice) taxBits.push(`ICE: ${esc(c.ice)}`);
      if (c.tp) taxBits.push(`TP: ${esc(c.tp)}`);
      if (c.cnss) taxBits.push(`CNSS: ${esc(c.cnss)}`);
      const line4 = taxBits.join(' | ');

      const html = `
        <html>
          <head>
            <title>Liste des Factures</title>
            <style>
              @page { size: A4 portrait; margin: 16mm; }
              body{font-family: Arial, Helvetica, sans-serif; margin:0;}
              .header{position:fixed; top:0; left:0; right:0; text-align:center; padding-top:6mm;}
              .header img{ max-height:40px; }
              .wrap{ margin: 60px 0 70px 0; }
              h3{ margin: 0 0 10px 0; }
              table{width:100%;border-collapse:collapse}
              th,td{border:1px solid #ccc;padding:6px;text-align:left;font-size:12px}
              thead th{background:#1E68A3;color:#fff}
              .footer{position:fixed; left:16mm; right:16mm; bottom:10mm; font-size:11px;}
              .page-num{position:fixed; right:16mm; bottom:6mm; color:#888; font-size:11px;}
            </style>
          </head>
          <body>
            <div class="header">${logo ? `<img src="${logo}" alt="logo"/>` : ''}</div>
            <div class="wrap">
              <h3>Liste des Factures</h3>
              <table>
                <thead>
                  <tr>
                    <th>Facture</th>
                    <th>Client</th>
                    <th>Date</th>
                    <th>Paiement</th>
                    <th>Déclarée</th>
                    <th>Total TTC</th>
                  </tr>
                </thead>
                <tbody>
                  ${rows.map(r => `
                    <tr>
                      <td>${esc(r.numero_facture || `FCT-${r.id}`)}</td>
                      <td>${esc(r.client_nom || "")}</td>
                      <td>${esc(r.date_creation || r.CreatedOn || "")}</td>
                      <td>${esc(r.Payment_Status || r.statut_paiement || "")}</td>
                      <td>${esc(r.declare_label || (r.declare ? "Déclarée" : "Non déclarée"))}</td>
                      <td>${r.montant_total != null ? esc(Number(r.montant_total).toFixed(2)) : ""}</td>
                    </tr>`).join("")}
                </tbody>
              </table>
            </div>
            <div class="footer">
              ${line1 ? `<div>${line1}</div>` : ''}
              ${line2 ? `<div>${line2}</div>` : ''}
              ${line3 ? `<div>${line3}</div>` : ''}
              ${line4 ? `<div>${line4}</div>` : ''}
            </div>
            <div class="page-num"></div>
          </body>
        </html>`;
      win.document.open();
      win.document.write(html);
      win.document.close();
      setTimeout(() => { try { win.focus(); win.print(); } catch (e) { /* ignore */ } }, 100);
    },

    // Refresh list from server and re-apply filters
    async refreshList() {
      try {
        await this.getFacturesData();
        this.applyFilters();
      } catch (e) {
        console.error(e);
      }
    },

    async loadCompanyData() {
      try {
        const result = await fetchCompanyData();
        const data = result?.data ?? result;
        this.company = {
          id: data.id,
          name: data.societe_nom,
          address: data.adress,
          email: data.email,
          tel: data.telephone_entreprise,
          telephone_entreprise: data.telephone_entreprise,
          ice: data.ice,
          if: data.identifiant_fiscal,
          rc: data.rc,
          code_postal: data.code_postal,
          telephone_personnel: data.telephone_personnel,
          cin: data.cin,
          tp: data.tp,
          cnss: data.cnss,
          lieu_naissance: data.lieu_naissance,
          nom_complet_arabe: data.nom_complet_arabe,
          nom_complet_francais: data.nom_complet_francais,
          nom_banque: data.nom_banque,
          rib: data.rib,
          code_banque_swift: data.code_banque_swift,
          adresse_siege_social_francais: data.adresse_siege_social_francais,
          webesite: data.webesite,
          url: data.url,
          capital: data.capital,
          logo: data.logo,
          logo_small: data.logo_small,
          document_logo_position: data.document_setting?.logo_position || data.document_logo_position,
          document_footer_text: data.document_setting?.footer_text ?? data.document_footer_text,
          document_footer_text_color: data.document_setting?.footer_text_color || data.document_footer_text_color,
          document_footer_alignment: data.document_setting?.footer_alignment,
          document_footer_font_size: data.document_setting?.footer_font_size,
          document_footer_font_weight: data.document_setting?.footer_font_weight,
          document_footer_fields: data.document_setting?.footer_fields,
          created_at: data.created_at,
        };
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
        toast.error(error.response.data.error);
      }
    },

    async handlePdf(devis, options = {}) {
      const clientCandidate = devis.commande?.client || this.findClient(devis.client_id);
      const clientData =
        clientCandidate && typeof clientCandidate === "object" ? clientCandidate : {};
      const clientDisplayName = (clientData.nom_societe && clientData.nom_societe.trim())
        ? clientData.nom_societe
        : [clientData.prenom, clientData.nom].filter(Boolean).join(" ").trim() || devis.client_nom || "Client";
      // const logoBase64 = await this.getBase64ImageFromUrl(
      //   `${process.env.VUE_APP_URL}storage/${this.company.logo_small}`
      // );
      // Removed unused local variables

      const products = [];
      try {
        const data = await getLignesCommandeDataByCommandeId(devis.commande_id);
        data.forEach((item) => {
          const t = item.item_data && (item.item_data.taux_tva ?? item.item_data.taux_taxe);
          const derived = item.montant_HT ? ((item.montant_TTC / item.montant_HT - 1) * 100) : 0;
          const tax = Number((t ?? derived).toString().replace(',', '.')) || 0;
          products.push({
            nameProduct: item.item_data ? item.item_data.nom : item.nom_libre,
            quantity: item.quantite,
            unit_price: item.prix_unitaire,
            tax,
            PTHT: item.montant_HT,
          });
        });
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Impossible de récupérer les lignes de la commande.";
        if (!options.silent) toast.error(message);
        if (options.returnBlob) throw error;
        return null;
      }
      const mockCommand = {
        type: "facture",
        nameClient: clientDisplayName,
        emailClient: clientData.email || "",
        adressClient: clientData.adresse || "",
        PhoneClient: clientData.telephone || "",
        clientType: devis.client_type || clientData.type || "",
        clientCompanyName: devis.client_nom_societe || clientData.nom_societe || "",
        clientIce: devis.client_ice || clientData.ice || "",
        date_created: devis.date_creation,
        Nbdevis: devis.numero_facture,
        client_id: devis.client_id,
        commande_id: devis.commande_id,
        terms_payment: devis.conditions_paiement || devis.commande?.conditions_paiement || "",
        conditions_paiement: devis.conditions_paiement || devis.commande?.conditions_paiement || "",
        mode_paiement: devis.mode_paiement || devis.commande?.mode_paiement || "",
        valide_jusqua: devis.valide_jusqua || devis.date_echeance || "",
        date_livraison: devis.date_livraison || devis.commande?.date_livraison || "",
        line: products,
        notes: devis.notes,
      };

      let logoSmall = "";
      try {
        logoSmall = await getCompanyLogoDataUrl('logo');
      } catch (_) { /* ignore logo load errors */ }

      const mockCompanyInfo = {
        logoSmall,
        name: this.company.name,
        address: this.company.address,
        postalCode: this.company.code_postal,
        email: this.company.email,
        website: this.company.url,
        companyLegalName: this.company.name,
        capital: this.company.capital,
        documentLogoPosition: this.company.document_logo_position,
        documentFooterText: this.company.document_footer_text,
        documentFooterTextColor: this.company.document_footer_text_color,
        documentFooterAlignment: this.company.document_footer_alignment,
        documentFooterFontSize: this.company.document_footer_font_size,
        documentFooterFontWeight: this.company.document_footer_font_weight,
        documentFooterFields: this.company.document_footer_fields,
        bankInfo: {
          name: this.company.nom_banque,
          rib: this.company.rib,
        },
        socialInfo: {
          address: this.company.adresse_siege_social_francais,
          phone: this.company.telephone_personnel,
          telephone_entreprise: this.company.telephone_entreprise,
          email: this.company.email,
          website: this.company.url,
        },
        taxId: {
          rc: this.company.rc,
          if: this.company.if,
          tp: this.company.tp,
          cnss: this.company.cnss,
          ice: this.company.ice,
        },
      };
      const mockfontData = {
        Roboto: {
          normal:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-Regular.ttf",
          bold: "https://www.google.com/search?q=http://example.com/fonts/Roboto-Bold.ttf",
          italics:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-Italic.ttf",
          bolditalics:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-BoldItalic.ttf",
        },
      };
      try {
        return await generateCommandPdf(mockCommand, mockCompanyInfo, mockfontData, options);
      } catch (error) {
        console.error("PDF generation failed:", error);
        if (options.returnBlob) throw error;
      }
    },

    async exportPDF() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      if (!rows || !rows.length) return;
      const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const headerHeight = 26;
      const margin = 12;

      let logo = null;
      try { logo = await getCompanyLogoDataUrl('logo'); } catch (e) { /* ignore */ }
      const drawHeader = () => {
        if (!logo) return;
        const w = 30, h = 12, x = (pageWidth - w) / 2, y = 8;
        try {
          const fmt = logo.startsWith('data:image/png') ? 'PNG' : 'JPEG';
          doc.addImage(logo, fmt, x, y, w, h);
        } catch (_) { /* ignore */ }
      };
      const drawFooter = () => {
        const c = this.company || {};
        const leftX = margin;
        let y = pageHeight - 22; // leave some space above bottom
        const maxWidth = pageWidth - 2 * margin;
        const lineHeight = 4.2;
        doc.setFontSize(9);
        const write = (text) => {
          if (!text) return;
          const wrapped = doc.splitTextToSize(String(text), maxWidth);
          wrapped.forEach((ln) => { doc.text(ln, leftX, y); y += lineHeight; });
        };

        const line1 = c.name ? String(c.name) : '';
        const line2 = [c.address, c.code_postal].filter(Boolean).join(' | ');
        const line3 = [c.email, c.url].filter(Boolean).join(' | ');
        const taxBits = [];
        if (c.rc) taxBits.push(`RC: ${c.rc}`);
        if (c.if) taxBits.push(`IF: ${c.if}`);
        if (c.ice) taxBits.push(`ICE: ${c.ice}`);
        if (c.tp) taxBits.push(`TP: ${c.tp}`);
        if (c.cnss) taxBits.push(`CNSS: ${c.cnss}`);
        const line4 = taxBits.join(' | ');

        write(line1);
        write(line2);
        write(line3);
        write(line4);
      };

      const body = rows.map((r) => [
        r.numero_facture || `FCT-${r.id}`,
        r.client_nom || '-',
        r.date_creation || r.CreatedOn || '-',
        r.statut_paiement || '-',
        r.declare_label || (r.declare ? 'Déclarée' : 'Non déclarée'),
        r.montant_total != null ? Number(r.montant_total).toFixed(2) + ' MAD' : '-',
      ]);

      const startY = headerHeight + 12;
      autoTable(doc, {
        startY,
        head: [['Facture', 'Client', 'Date', 'Paiement', 'Déclarée', 'Total TTC']],
        body,
        headStyles: { fillColor: [30, 104, 163], textColor: 255, fontStyle: 'bold', fontSize: 9, halign: 'center' },
        styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: {
          0: { cellWidth: 28 },
          1: { cellWidth: 50 },
          2: { cellWidth: 26, halign: 'center' },
          3: { cellWidth: 26, halign: 'center' },
          4: { cellWidth: 26, halign: 'center' },
          5: { cellWidth: 26, halign: 'right' },
        },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        didDrawPage: () => {
          drawHeader();
          drawFooter();
          const pageCount = doc.internal.getNumberOfPages();
          const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
          doc.setFontSize(9); doc.setTextColor(120);
          doc.text(`Page ${currentPage} sur ${pageCount}`, pageWidth - margin, pageHeight - 6, { align: 'right' });
          doc.setTextColor(0);
        },
        margin: { left: margin, right: margin, top: startY, bottom: 26 },
      });

      const timestamp = new Date().toISOString().slice(0, 10);
      const filename = `factures_${timestamp}.pdf`;
      doc.save(filename);
    },

    exportCSV() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      if (!rows || !rows.length) return;
      const headers = ['Facture', 'Client', 'Date', 'Paiement', 'Déclarée', 'Total TTC'];
      const csv = [
        headers.join(','),
        ...rows.map(r => [
          r.numero_facture || `FCT-${r.id}`,
          r.client_nom || '',
          r.date_creation || r.CreatedOn || '',
          r.statut_paiement || '',
          r.declare_label || (r.declare ? 'Déclarée' : 'Non déclarée'),
          r.montant_total != null ? r.montant_total : ''
        ].map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
      ].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `factures_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    },
  },
  async mounted() {
    const user = getCurrentUser();
    this.currentUser = user;
    this.isAdmin = String(user?.role || "").toLowerCase() === "admin";
    await this.getClientsData();
    await this.getFacturesData();
    await this.loadCompanyData();
    this.applyFilters();
  },
};
</script>

<style scoped>
.declare-select {
  min-width: 140px;
}

.page-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}

.page-wrapper.sales-list {
  position: relative;
}

.dashboard-spinner {
  width: 48px;
  height: 48px;
}

.invoice-detail-modal {
  border: 0;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.22);
  overflow: hidden;
}

.invoice-detail-header {
  background: #fff;
  border-bottom: 1px solid #e8edf3;
  padding: 20px 24px;
}

.invoice-detail-eyebrow,
.invoice-company-label,
.invoice-number-label {
  color: #8a98aa;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .09em;
  text-transform: uppercase;
}

.invoice-detail-header .modal-title {
  color: #102a43;
  font-size: 21px;
  font-weight: 700;
  margin-top: 2px;
}

.invoice-detail-body {
  background: #f7f9fc;
  padding: 24px;
}

.invoice-hero {
  background: linear-gradient(135deg, #102a43 0%, #1f4f78 100%);
  border-radius: 14px;
  color: #fff;
  padding: 22px 24px;
}

.invoice-hero .text-muted,
.invoice-hero .invoice-company-label,
.invoice-hero .invoice-number-label {
  color: rgba(255, 255, 255, 0.72) !important;
}

.invoice-number {
  font-size: 22px;
  font-weight: 750;
  letter-spacing: .01em;
}

.invoice-info-card,
.invoice-totals-card,
.invoice-lines {
  background: #fff;
  border: 1px solid #e5eaf0;
  border-radius: 13px;
  padding: 18px;
}

.invoice-card-title,
.invoice-section-title {
  align-items: center;
  color: #334e68;
  display: flex;
  font-size: 13px;
  font-weight: 700;
  gap: 7px;
  margin-bottom: 13px;
  text-transform: uppercase;
}

.invoice-lines {
  padding: 0;
  overflow: hidden;
}

.invoice-section-title {
  border-bottom: 1px solid #edf1f5;
  margin: 0;
  padding: 16px 18px;
}

.invoice-lines-table :deep(.ant-table-thead > tr > th) {
  background: #f1f5f9 !important;
  color: #526579;
  font-size: 12px;
  padding: 12px 14px !important;
  text-transform: uppercase;
}

.invoice-lines-table :deep(.ant-table-tbody > tr > td) {
  padding: 13px 14px !important;
}

.invoice-totals-card {
  padding: 20px;
}

.invoice-total-divider {
  border-top: 1px dashed #cbd5e1;
  margin: 14px 0;
}

.invoice-detail-actions {
  border-top: 1px solid #e5eaf0;
  margin: 22px -24px -24px;
  padding: 18px 24px;
  background: #fff;
}

.invoice-batch-bar {
  align-items: center;
  background: linear-gradient(135deg, #eef6ff 0%, #f7faff 100%);
  border: 1px solid #cfe2ff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  margin: 4px 0 18px;
  padding: 12px 14px;
}

.invoice-batch-summary,
.invoice-batch-actions,
.batch-download-btn {
  align-items: center;
  display: flex;
}

.invoice-batch-summary {
  gap: 11px;
}

.invoice-batch-summary strong,
.invoice-batch-summary small {
  display: block;
}

.invoice-batch-summary strong {
  color: #0b2f53;
  font-size: 14px;
}

.invoice-batch-summary small {
  color: #64748b;
  margin-top: 2px;
}

.invoice-batch-icon {
  align-items: center;
  background: #dbeafe;
  border-radius: 9px;
  color: #2563eb;
  display: flex;
  height: 38px;
  justify-content: center;
  width: 38px;
}

.invoice-batch-icon :deep(svg) {
  height: 19px;
  width: 19px;
}

.invoice-batch-actions {
  gap: 8px;
}

.invoice-batch-actions .btn-link {
  color: #526579;
  text-decoration: none;
}

.batch-download-btn {
  gap: 8px;
  justify-content: center;
}

.batch-download-btn :deep(svg) {
  height: 18px;
  width: 18px;
}

.batch-bar-enter-active,
.batch-bar-leave-active {
  transition: opacity .18s ease, transform .18s ease;
}

.batch-bar-enter-from,
.batch-bar-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

@media (max-width: 767px) {
  .invoice-batch-bar,
  .invoice-batch-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .invoice-batch-actions {
    margin-top: 12px;
  }

  .invoice-batch-actions .btn {
    width: 100%;
  }

  .invoice-detail-body {
    padding: 16px;
  }

  .invoice-hero {
    flex-direction: column;
    gap: 18px;
  }

  .invoice-hero .text-end {
    text-align: left !important;
  }

  .invoice-detail-actions {
    margin: 18px -16px -16px;
  }
}
</style>
